import notificationService from './notificationService'
import { notificationTypes } from '../components/Default/NotificationCenter/constants'
import { evaluateLowResolutionImages } from './lowResolutionImageRules'

// Single writer of the low-resolution-images notification. Driven by the
// property's images, image galleries and rooms (from PropertyPage), so it
// follows uploads, deletions, gallery assignments and rooms being removed. One
// notification represents the current property-level state rather than one per
// detected image.
const NOTIFICATION_ID = 'low-resolution-images'

let lastSignature = null

/**
 * Evaluates the property's images and pushes/dismisses the
 * low-resolution-images notification accordingly.
 *
 * Guards on a signature of the result so re-running with an unchanged count and
 * target is a no-op (the notification isn't needlessly re-pushed / re-marked
 * unread).
 *
 * @param {Array<Object>} images the property's images
 * @param {{ property: Object, rooms: Object }} galleries the property's image galleries
 * @param {Array<{ id: string }>} rooms the property's rooms
 */
export const syncLowResolutionImageNotification = (images, galleries, rooms) => {
  const result = evaluateLowResolutionImages(images, galleries, rooms)
  const signature = result ? `${result.count}|${result.target}` : ''

  if (signature === lastSignature) {
    return
  }
  lastSignature = signature

  if (result) {
    notificationService.push({
      id: NOTIFICATION_ID,
      type: notificationTypes.LOW_RESOLUTION_IMAGES,
      payload: result,
    })
  } else {
    notificationService.dismiss(NOTIFICATION_ID)
  }
}

/**
 * Clears the notification and the signature tracker — call when leaving a
 * property or switching to another one, so the next property re-emits its own
 * state.
 */
export const resetLowResolutionImageNotification = () => {
  lastSignature = null
  notificationService.dismiss(NOTIFICATION_ID)
}
